import React from 'react';
import classNames from 'classnames';

import IconRenderer, { IconProps } from 'ui/icons/IconRenderer';

import icon from './explicit.svg';

import styles from './index.module.scss';

const Explicit = ({ className, style }: IconProps) => (
  <IconRenderer
    iconHtml={icon}
    className={classNames(styles.icon, className)}
    style={style}
  />
);

export default Explicit;
